module.exports = __webpack_public_path__ + "static/img/4_1.f077fe87.jpg";